<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import {
    mapState,
    mapMutations,
    mapActions
  } from "vuex";

  export default {
    created() {
      //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("store")) {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
      }
      //在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener("beforeunload", () => {
        sessionStorage.setItem("store", JSON.stringify(this.$store.state))
      })
    },
    mounted() {
      // H5软键盘弹出屏幕闪动问题
      window.onresize = () => {
        return (() => {
          document.body.style.height = document.body.clientHeight;
        })()
      }

      this.getEnv();
      console.log(this.$route.query);
      this.getConfigs(this.$route.query.hospid);
      this.setTheme();
    },
    methods: {
      ...mapActions(
        "hospital", {
          getEnv: "getEnv",
          getConfigs: "getConfigs",
          setAssets: "setAssets"
        }
      ),
      setTheme() {
        this.$nextTick(() => {
          const app = document.querySelector('#app');
          //document.documentElement.style.setProperty('--color-main', '#B8860E');
          //document.documentElement.style.setProperty('--color-main', '#308ADB');
          //app.dataset.theme = theme;
          const skin = window.themes.skin;
          if (!skin)
            return;
          const theme = window.themes[skin];
          if (!theme)
            return

          let assets = [];
          for (var key in theme) {
            document.documentElement.style.setProperty(key, theme[key]);
            assets.push({
              name: key,
              value: theme[key]
            })
          }

          this.setAssets(assets);
          // document.documentElement.style.setProperty('--color-main', theme.mainColor);
          // document.documentElement.style.setProperty('--color-main-light', theme.gradientColor);
        })
      },
    },
  }
</script>

<style lang="less">
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-height: 100%;
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>